import { render, staticRenderFns } from "./InputComponent.vue?vue&type=template&id=3bb7772d&"
import script from "./InputComponent.vue?vue&type=script&lang=js&"
export * from "./InputComponent.vue?vue&type=script&lang=js&"
import style0 from "./InputComponent.vue?vue&type=style&index=0&id=3bb7772d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports